export function get_any_transmitter_id(definitions) {
    for (const o of Object.values(definitions.devices)) {
        if (o.transmitter_kind) {
            return o.id;
        }
    }
    return undefined;
}
